import type { TeamMember } from "../../types";

export const gitlabTeam: TeamMember[] = [
  {
    name: "Glen Balliet",
    title: "Founder & CEO",
    email: "glen@null.autos",
    previousCompanies: ["CARIAD", "Rivian", "American Express", "Nike"],
    photo: "/assets/images/team/glen.jpg",
  },
];
